// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

ion-list {
  padding: 0;
  max-height: 353px;
  overflow-y: auto;
  background: none;
  height: 100%;
}
ion-list ion-item {
  height: 55px;
  margin: 0;
  --min-height: 55px;
  --background: #ffffff !important;
  --border-radius: 8px;
  margin: 4px 0;
}
ion-list ion-item.OUT_OF_ORDER {
  opacity: 0.4;
}
ion-list ion-item ion-avatar {
  display: flex;
  align-items: center;
  margin: 0;
  max-width: 22px;
}
ion-list ion-item ion-avatar vl-icon {
  height: 17px;
  line-height: 17px;
}
ion-list ion-item ion-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
ion-list ion-item ion-label h3 {
  font-size: 1rem;
  margin: 0;
  width: 33%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
ion-list ion-item ion-label .address {
  font-family: "Roboto-Regular";
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: var(--vl-red);
  width: 40%;
}
ion-list ion-item ion-label span {
  display: block;
  font-size: 0.75rem;
  font-family: var(--roboto-regular);
  font-weight: 400;
  color: var(--vl-black-font-light);
  width: 27%;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 576px) {
  ion-list ion-item ion-label h3 {
    width: 50%;
  }
  ion-list ion-item ion-label span {
    width: 50%;
  }
  .address {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/home-wrapper/facilities/facilities-list/facilities-list.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EAEE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAyDF;AAvDE;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,oBAAA;EACA,aAAA;AAyDJ;AAxDI;EACE,YAAA;AA0DN;AAtDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAwDN;AAtDM;EACE,YAAA;EACA,iBAAA;AAwDR;AAnDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAqDN;AApDM;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAsDR;AAnDM;EACE,6BDzCS;EC0CT,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AAqDR;AAlDM;EACE,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAoDR;;AA9CA;EAEI;IACE,UAAA;EAgDJ;EA9CE;IACE,UAAA;EAgDJ;EA7CA;IACE,aAAA;EA+CF;AACF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\nion-list {\n  // margin-top: 70px;\n  padding: 0;\n  max-height: 353px;\n  overflow-y: auto;\n  background: none;\n  height: 100%;\n\n  ion-item {\n    height: 55px;\n    margin: 0;\n    --min-height: 55px;\n    --background: #ffffff !important;\n    --border-radius: 8px;\n    margin: 4px 0;\n    &.OUT_OF_ORDER {\n      opacity: 0.4;\n    }\n\n\n    ion-avatar {\n      display: flex;\n      align-items: center;\n      margin: 0;\n      max-width: 22px;\n\n      vl-icon {\n        height: 17px;\n        line-height: 17px;\n      }\n    }\n\n\n    ion-label {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      h3 {\n        font-size: 1rem;\n        margin: 0;\n        width: 33%;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n\n      .address {\n        font-family: $roboto-regular;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        color: var(--vl-red);\n        width: 40%;\n      }\n\n      span {\n        display: block;\n        font-size: 0.75rem;\n        font-family: var(--roboto-regular);\n        font-weight: 400;\n        color: var(--vl-black-font-light);\n        width: 27%;\n        display: flex;\n        justify-content: flex-end;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  ion-list ion-item ion-label {\n    h3 {\n      width: 50%;\n    }\n    span {\n      width: 50%;\n    }\n  }\n  .address {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
